<template>
  <c-dialog title="微信公众号扫码绑定" :visible="visible" :append-to-body="true" width="720px" @close='dialogOnClose'>
    <el-row >
        <el-col :span="24" align="center" type="flex">
          <div id="qrcode" style="width:100%;text-align：center;margin-bottom: 20px;"></div>
        </el-col>
        <el-col :span="24" align="center" type="flex" style="margin-bottom: 20px">
          <span v-if="countDown > 0" style="color:red;">{{ countDown }} 秒后二维码失效</span>
          <span v-if="countDown === 0" style="color:red">点击按钮刷新二维码</span>
        </el-col>
        <el-col :span="24" align="center" type="flex" v-show="countDown === 0">
          <el-button type="primary" @click="refreshQROnClick()">刷新绑定二维码</el-button>
        </el-col>
      </el-row>
  </c-dialog>
</template>
<script>

import QRCode from 'qrcodejs2'
import { Message } from 'element-ui'
import PermissionButton from '@/components/Buttons/permission-button'
import LoadingButton from '@/components/Buttons/loading-button'

export default {
  name: 'openAccountBindWX',
  components: {
    LoadingButton,
    PermissionButton
  },
  props: {
    modelValue: Boolean
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  watch: {
    modelValue: {
      handler (oldV, newV) {
        if (oldV) {
          this.fetchData()
        }
      }
    }
  },
  computed: {
    visible: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  data () {
    return {
      showWechatQrLogin: false,
      countDown: 0,
      countDownTimer: null
    }
  },
  created () {
  },
  methods: {
    async fetchData () {
      this.fetchQrUuid()
    },
    async fetchQrUuid () {
      try {
        if (this.countDownTimer) {
          clearInterval(this.countDownTimer)
          this.countDownTimer = null
        }
        const result = await this.$store.dispatch('MerchantAuth/getWxLoginUuid')
        const h5PageURL = `${process.env.H5_WX_AUTHORIZE_URL}/account/bind`
        const url = `${h5PageURL}?uuid=${result.uuid}&adminId=${result.adminId}&merchantId=${result.merchantId}&nonStr=${result.nonStr}&time=${result.time}`
        await this.showQRCode('qrcode', url, '', false)
        this.startCountDown()
      } catch (error) {
        Message({
          message: error.message,
          type: 'error',
          duration: 10 * 1000
        })
      }
    },
    async refreshQROnClick () {
      this.fetchQrUuid()
    },
    async showQRCode (divName, content, filename, isDownload) {
      if (document.getElementById(divName)) {
        document.getElementById(divName).innerHTML = ''
      }
      let qrcode = new QRCode(divName, {
        width: 200,
        height: 200, // 高度
        text: content + ''
      })
      console.log(qrcode)
      // 先找到canvas节点下的二维码图片
      let myCanvas = document.getElementById(divName).getElementsByTagName('canvas')
      let img = document.getElementById(divName).getElementsByTagName('img')
      // 创建一个a节点
      let a = document.createElement('a')
      // 设置a的href属性将canvas变成png格式
      let imgURL = myCanvas[0].toDataURL('image/jpg')
      let ua = navigator.userAgent
      if (ua.indexOf('Trident') !== -1 && ua.indexOf('Windows') !== -1) { // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(',')[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        var blob = new Blob([u8arr])
        if (isDownload) window.navigator.msSaveOrOpenBlob(blob, filename + '.' + 'png')
      } else if (ua.indexOf('Firefox') > -1) { // 火狐兼容下载
        let blob = this.base64ToBlob(imgURL) // new Blob([content]);
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', true, true) // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        a.download = ' ' // 下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob)
        a.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window})) // 兼容火狐
      } else { // 谷歌兼容下载
        img.src = myCanvas[0].toDataURL('image/jpg')
        // a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream')
        a.href = img.src
        // 设置下载文件的名字
        a.download = filename
        // 点击
        if (isDownload) a.click()
      }
    },
    async startCountDown () {
      this.countDown = 60
      this.countDownTimer = setInterval(() => {
        this.countDown = this.countDown - 1
        if (this.countDown === 0) {
          clearInterval(this.countDownTimer)
          this.countDownTimer = null
        }
      }, 1000)
    },
    async dialogOnClose () {
      this.$emit('onClosed')
    }
  }
}

</script>

<style  lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/components/open-account-bind-wx.vue